import styles from './TelegramCHannel.module.css'
import icTelegram from './../../../../image/ic_telegram.svg'
export const TelegramChannel = () =>{
    return (
        <div className={styles.telegram_container} onClick={()=>window.location.href='https://t.me/+aeYFGWDBNs1kMWQy'}>
            <img src={icTelegram}/>
            <div className={styles.telegram_container_body}>Telegram-канал проекта</div>
        </div>
    )
}